export namespace EditFeatureModalHelper {
  export const errorText = {
    required: 'FEATURE-VALUE-EDIT-MODAL.ERROR_MSG.REQUIRED',
    min: 'FEATURE-VALUE-EDIT-MODAL.ERROR_MSG.MIN',
    max: 'FEATURE-VALUE-EDIT-MODAL.ERROR_MSG.MAX',
    pattern: 'FEATURE-VALUE-EDIT-MODAL.ERROR_MSG.NUMBERS_PATTERN',
  };
}
